/* Choctaw Motorcycles — small helpers for the ch- sections */
(function () {
  const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const fmt = (h) => {
    const hr = Math.floor(h), min = Math.round((h - hr) * 60);
    const suffix = hr >= 12 ? 'pm' : 'am';
    const h12 = hr % 12 === 0 ? 12 : hr % 12;
    return min ? `${h12}:${String(min).padStart(2, '0')}${suffix}` : `${h12}${suffix}`;
  };

  // Opening hours come from the theme settings, printed on <body data-ch-hours="...">
  function readHours() {
    const raw = document.body.dataset.chHours;
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (_) { return null; }
  }

  function londonNow() {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
    const get = (t) => parts.find((p) => p.type === t).value;
    return { day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday')), now: +get('hour') + +get('minute') / 60 };
  }

  function initStatus(root) {
    const hours = readHours();
    if (!hours) return;
    let day, now;
    try { ({ day, now } = londonNow()); } catch (_) { return; }

    root.querySelectorAll('[data-ch-status]').forEach((el) => {
      const today = hours[day];
      const label = el.querySelector('[data-ch-status-text]');
      const dot = el.querySelector('.ch-dot');
      if (today && now >= today[0] && now < today[1]) {
        label.textContent = `Workshop open now · until ${fmt(today[1])}`;
        dot && dot.classList.add('is-open');
        return;
      }
      for (let i = 0; i <= 7; i++) {
        const d = (day + i) % 7;
        const h = hours[d];
        if (!h) continue;
        if (i === 0 && now >= h[0]) continue;
        const when = i === 0 ? 'today' : i === 1 ? 'tomorrow' : DAYS[d];
        label.textContent = `Closed now · opens ${when} ${fmt(h[0])}`;
        return;
      }
    });

    root.querySelectorAll('[data-ch-days]').forEach((row) => {
      if (row.dataset.chDays.split(',').includes(String(day))) row.classList.add('is-today');
    });
  }

  function initCopy(root) {
    root.querySelectorAll('[data-ch-copy]').forEach((btn) => {
      if (btn.dataset.chBound) return;
      btn.dataset.chBound = '1';
      btn.addEventListener('click', () => {
        const text = btn.dataset.chCopy;
        const done = () => { btn.textContent = 'Copied'; setTimeout(() => { btn.textContent = 'Copy'; }, 1800); };
        const fallback = () => {
          const target = btn.previousElementSibling;
          const range = document.createRange();
          range.selectNodeContents(target);
          const sel = getSelection(); sel.removeAllRanges(); sel.addRange(range);
          btn.textContent = 'Selected';
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, fallback);
        else fallback();
      });
    });
  }

  // Buttons like "Enquire" pre-fill the enquiry form
  function initPrefill(root) {
    root.querySelectorAll('[data-ch-service]').forEach((btn) => {
      if (btn.dataset.chBound) return;
      btn.dataset.chBound = '1';
      btn.addEventListener('click', () => {
        const select = document.querySelector('#ChEnquiryService');
        const message = document.querySelector('#ChEnquiryMessage');
        const value = btn.dataset.chService;
        if (select) {
          const match = [...select.options].find((o) => value.startsWith(o.value));
          if (match) select.value = match.value;
        }
        const about = btn.dataset.chAbout;
        if (message && about && !message.value) message.value = `I'm interested in the ${about}.`;
      });
    });
  }


  // ---------- Header: mobile menu, back to top, cart count ----------
  function initHeader() {
    const wrap = document.getElementById('ChHeader');
    const burger = document.getElementById('ChBurger');
    const nav = document.getElementById('ChNav');
    if (burger && nav && !burger.dataset.chBound) {
      burger.dataset.chBound = '1';
      const setOpen = (open) => {
        if (wrap) document.documentElement.style.setProperty('--ch-header-bottom', wrap.getBoundingClientRect().bottom + 'px');
        nav.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', String(open));
        burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        document.body.classList.toggle('ch-nav-open', open);
      };
      burger.addEventListener('click', () => setOpen(!nav.classList.contains('is-open')));
      nav.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setOpen(false)));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });
    }

    const toTop = document.getElementById('ChToTop');
    if (toTop && !toTop.dataset.chBound) {
      toTop.dataset.chBound = '1';
      const onScroll = () => { toTop.hidden = window.scrollY < 700; };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      toTop.addEventListener('click', (e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
    }
  }

  async function refreshCartCount(showToast) {
    try {
      const res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-ch-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
        const link = el.closest('a');
        if (link) link.setAttribute('aria-label', `Cart, ${cart.item_count} items`);
      });
      const toast = document.getElementById('ChCartToast');
      if (showToast && toast && cart.item_count > 0) {
        toast.hidden = false;
        clearTimeout(toast._t);
        toast._t = setTimeout(() => { toast.hidden = true; }, 5000);
      }
    } catch (_) { /* leave the count as rendered */ }
  }
  // The theme fires 'cart:update' after every add to cart / quantity change
  document.addEventListener('cart:update', (e) => {
    const source = e.detail && e.detail.data && e.detail.data.source;
    refreshCartCount(!source || String(source).indexOf('cart') === -1);
  });

  function init(root) { initStatus(root); initCopy(root); initPrefill(root); initHeader(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);

  // Re-run when sections are edited in the Shopify theme editor
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
